var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2557 10.2914C11.2557 11.6009 10.1937 12.6622 8.88418 12.6622C7.57468 12.6622 6.51343 11.6009 6.51343 10.2914C6.51343 8.98117 7.57468 7.91992 8.88418 7.91992C10.1937 7.91992 11.2557 8.98117 11.2557 10.2914Z",
    stroke: "#525355",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8225 10.2908C14.3518 7.19477 11.7395 5.3374 8.88351 5.3374H8.88651C6.03051 5.3374 3.41826 7.19477 1.94751 10.2908",
    stroke: "#525355",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOnly);
export default __webpack_public_path__ + "static/media/viewOnly.0dcd5a8434ccb491b27b011219fd0aa9.svg";
export { ForwardRef as ReactComponent };